<app-timeout></app-timeout>
<div class="container-fluid app-content-view">
  @if (isUserAuthorized) {
    @if (!!gridDataModel && !visiblNoMatchesFoundPopup) {
      <div class="search-results-container">
        @if (isPagingVisible) {
          <opm-paging [totalRecords]="totalCount" [currentPage]="currentPage"
                      (pageChanged)="onPageChange($event)">
          </opm-paging>
        }

        @switch (gridResult) {
          @case (gridResultEnum.OnboardedApp) {
            <opm-grid [metaName]="gridTypeEnum.OnboardedApp" [users]="gridDataModel.OnboardedAppDetails" [onBoardedApps]="onBoardedAllApps.OnboardedAppDetails" [totalRecords]="totalCount"></opm-grid>
          }
        }

        @if (isPagingVisible) {
          <opm-paging [totalRecords]="totalCount" [currentPage]="currentPage"
                      (pageChanged)="onPageChange($event)">
          </opm-paging>
        }
      </div>
    }

    @if (visiblNoMatchesFoundPopup) {
      <opm-modal-popup header="Onboarded App" [cancelVisibility]="false"
                       message="{{noMatchesFoundMsg}}" okButtonName="Ok" (onOk)="gridDataModel = null; visiblNoMatchesFoundPopup = false">
      </opm-modal-popup>
    }
  }

  @if (!isUserAuthorized) {
    <div class="user-unauthorized">{{errorMessage}}</div>
  }
</div>
<opm-footer></opm-footer>
